import React from 'react';
import PremiumLoader from '../../components/PremiumLoader';

/** Full-screen loader — premium museum theme */
const ArtmosphereLoader = ({ isVisible, message = 'One moment…' }) => {
  if (!isVisible) return null;
  return <PremiumLoader message={message} variant="overlay" />;
};

export default ArtmosphereLoader;
